'use strict';

var Listener = require('../core/Listener.js');

/**
 * @classdesc This class should be used instead of requestAnimationFrame() --
 *            which is used by this class. This class breaks each frame into
 *            two phases ('read' and 'write') to help improve performance and avoid relayouts.
 */
var FrameManager = {};
Listener.init(FrameManager);

FrameManager._timestamp = performance.now();

FrameManager.getTimestamp = function() {
	return FrameManager._timestamp;
}

var lastTimestamp;
function onFrame(timestamp) {
	FrameManager._timestamp = timestamp;
	
	var frameDuration = (lastTimestamp !== undefined)? timestamp - lastTimestamp : 0;
	var data = {
		timestamp: timestamp,
		frameDuration: frameDuration
	};
	
	FrameManager.trigger('read', data);
	FrameManager.trigger('write', data);
	
	lastTimestamp = timestamp;
	
	requestAnimationFrame(onFrame);	
}
requestAnimationFrame(onFrame);

module.exports = FrameManager;

